import angular from 'angular';

export default angular
	.module('ui.cian.compile-directive', [])
	.directive('cianUiCompileDirective', () => ({
		restrict: 'EA',
		bindToController: {
			directive: '@',
			attributes: '='
		},
		controller: ['$injector', '$compile', '$element', '$scope', '$attrs', '$log', function ($injector, $compile, $element, $scope, $attrs, $log) {
			let childScope;
			$scope.$watch(() => {
				return this.directive;
			}, () => {
				if (childScope) {
					childScope.$destroy();
				}
				childScope = $scope.$new();
				const normalizedDirectiveName = `${$attrs.$normalize(this.directive)}Directive`;
				if (!$injector.has(normalizedDirectiveName)) {
					$log.error(`Directive ${this.directive} (${normalizedDirectiveName}) is not registered`, this);
				}
				if (!this.attributes) {
					$log.warn(`No attributes provided for directive ${this.directive} (${normalizedDirectiveName})`, this);
				}
				const attributesAsString = Object.keys(this.attributes).map(key => `${key}='${this.attributes[key]}'`).join(' ');
				$element.html(`<${this.directive} ${attributesAsString}></${this.directive}>`);

				$compile($element.contents())(childScope);
			});
		}],
		controllerAs: 'compileDirectiveCtrl'
	}))
	.name;
